export default "__VITE_ASSET__TcMbxSPQ__"